import { render, staticRenderFns } from "./virtualSelect.vue?vue&type=template&id=2d66aae8&scoped=true&"
import script from "./virtualSelect.vue?vue&type=script&lang=js&"
export * from "./virtualSelect.vue?vue&type=script&lang=js&"
import style0 from "./virtualSelect.vue?vue&type=style&index=0&id=2d66aae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d66aae8",
  null
  
)

export default component.exports